import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase.js';
import { useState, useEffect } from 'react';

// a card that shows image, name and price of a dish
// when clicked takes you to that dishes page
export default function DishCard({dishInfo}) {

  const navigate = useNavigate();

  const pageURL = '/menu/' + dishInfo.name;

  const fetchImageUrl = async (path) => {
    const storageRef = ref(storage, path);
  
    try {
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error("Error fetching image URL:", error);
      return null;
    }
  };

  const [dishImage, setDishImage] = useState("");
  useEffect(() => {
    const get_dish_image = async () => {
      const url = await fetchImageUrl(dishInfo.imagePath);
      setDishImage(url);
    };

    get_dish_image();
  }, [])


  return (
    <Card sx={{display: "flex", flexGrow: 1, m:1, w: 1, minHeight: 50, backgroundColor: "#e6e6e6" }}
    style={{
      border: "none", boxShadow: "none",
    }} 
    onClick={() => navigate(pageURL,  { state: { dishInfo } })}>
      <CardActionArea>
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            }}
        >
          <CardMedia
            component="img"
            sx = {{
              width: 100,
              minWidth: 100,
              height: 100,
            }}
            image={dishImage}
            alt={"picture of " +  dishInfo.name}
          />
          <CardContent>
            <Typography gutterBottom variant="subtitle1" component="div">
              {dishInfo.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              ${ dishInfo.price}
            </Typography>
          </CardContent>
        </Box>       
      </CardActionArea>
    </Card>
  );
}